import React from "react";
import ReactDOM from "react-dom";
import styles from "./OrderViewsModal.module.scss";
import { t } from "i18next";
import { Building2, Eye, Clock } from "lucide-react";

const OrderViewsModal = ({ isOpen, onClose, orderViews = [] }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const totalQuantity = orderViews.reduce((sum, item) => sum + item.quantity, 0);

  const renderSaasModal = () => (
    <>
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{t("orderViews.viewsTitle")}</h2>
        <div className={styles.totalBadgeBlue}>
          <Eye size={16} />
          <span>
            {totalQuantity} {t("orderViews.viewsCount", { count: totalQuantity })}
          </span>
        </div>
      </div>

      <div className={styles.modalBody}>
        {orderViews && orderViews.length > 0 ? (
          <div className={styles.viewsList}>
            {orderViews.map((view, index) => (
              <div key={`${view.userId}-${index}`} className={styles.viewItem}>
                <div className={styles.viewItemIcon}>
                  <Building2 size={24} color="#155DFC" />
                </div>
                <div className={styles.viewItemContent}>
                  <div className={styles.viewItemName}>
                    {view.userCompanyName || view.userFIO || t("orderViews.unknown")}
                  </div>
                </div>
                <div className={styles.viewItemStats}>
                  <div className={styles.viewItemRow}>
                    <Eye size={16} color="#99A1AF" />
                    <span>
                      {view.quantity} {t("orderViews.viewsCount", { count: view.quantity })}
                    </span>
                  </div>
                  <div className={styles.viewItemRow}>
                    <Clock size={16} color="#99A1AF" />
                    <span>{formatDate(view.updatedAt)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <p>{t("orderViews.noViews")}</p>
          </div>
        )}
      </div>
    </>
  );

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose} data-portal-modal="true">
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          type="button"
          style={{ top: "1px", right: "1px" }}
        >
          ✕
        </button>
        {renderSaasModal()}
      </div>

    </div>,
    document.body
  );
};

export default OrderViewsModal;
